import { getAuth, signOut } from "firebase/auth";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function useSignOut(): () => void {
  const navigate = useNavigate();

  const signOutCallback = useCallback(() => {
    signOut(getAuth())
      .then(() => navigate("/login"))
      .catch((signOutError) => {
        console.error("signOut error:", signOutError);
      });
  }, [navigate]);

  return signOutCallback;
}
